import {
	InjectionToken
} from '@angular/core';

export const ROUTES_CONFIG = new InjectionToken('routes.config');

const routeNames = {
	accueil: '',

	error404: '404',
	error500: '500',
	errorForteAffluence: 'forteAffluence',
	errorInactivite: 'errorInactivite',
	errorSessionExpiree: 'sessionExpiree'
};

const routesTitles = {
	accueil: 'AVVC'
};

const externUrls = {

};

export const RoutesConfig: any = {
	routeNames,
	externUrls,
	routesTitles
};
